import { render, staticRenderFns } from "./AddNewCommissionModal.vue?vue&type=template&id=186efcdc"
import script from "./AddNewCommissionModal.vue?vue&type=script&lang=js"
export * from "./AddNewCommissionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports